import React from 'react'
import PropTypes from 'prop-types'
import { Card, Typography } from '@chilecompra/react-kit/components'
import { LetterBlue } from './PurchaseOrderChangeStatusDialog.styles'

/**
 * The PurchaseOrder's component.
 */
const PurchaseOrder = props => {
  const { code, codePO, namePO, onSeeQuoteSummary, status, cancelAutomatic } = props

  const handleSeeQuoteSummary = () => onSeeQuoteSummary(code)

  return (
    <>
      {cancelAutomatic === 0 ? (
        <Card margin="0 0 4px">
          <Typography align="center" color="black1" fontSize="16px" fontWeight="bold" lineHeight="20px" variant="body1">
            Orden de Compra {codePO} {status}
          </Typography>
          <Typography align="center" color="black2" fontSize="13px" lineHeight="18px" variant="body2">
            {namePO}
          </Typography>
          <LetterBlue onClick={handleSeeQuoteSummary}>Ver ficha Compra Ágil</LetterBlue>
        </Card>
      ) : (
        <Card margin="0 0 4px">
          <Typography align="center" color="black1" fontSize="16px" fontWeight="bold" lineHeight="20px" variant="body1">
            Compra Ágil {code} {status}
          </Typography>
          <Typography align="center" color="black2" fontSize="13px" lineHeight="18px" variant="body2">
            Debido a la no selección de ningún proveedor, se ha cancelado automáticamente la Compra Ágil {code}. Te
            recordamos que tienes 30 días corridos para seleccionar un proveedor y enviar su Orden de Compra.
          </Typography>
          <LetterBlue onClick={handleSeeQuoteSummary}>Ver ficha Compra Ágil</LetterBlue>
        </Card>
      )}
    </>
  )
}

PurchaseOrder.defaultProps = {
  code: '',
  codePO: '',
  namePO: '',
  onSeeQuoteSummary: () => undefined,
  status: '',
  cancelAutomatic: 0
}

PurchaseOrder.propTypes = {
  code: PropTypes.string,
  codePO: PropTypes.string,
  namePO: PropTypes.string,
  onSeeQuoteSummary: PropTypes.func,
  status: PropTypes.string,
  cancelAutomatic: PropTypes.number
}

export default PurchaseOrder
